export const categoriaColore = {
  scarsa_illuminazione: '#f59e0b',
  comportamenti_sospetti: '#ef4444',
  strade_danneggiate: '#8b5cf6',
  altro: '#6b7280'
};
